export default __webpack_public_path__ + "static/media/step_A@2x.a147ef97.png";